export const CLIMATE_ACTION_INVALID_DATE_RANGE_CODE = "CLIMATE_ACTION_INVALID_DATE_RANGE";
export const PROJECT_INVALID_DATE_RANGE_CODE = "PROJECT_INVALID_DATE_RANGE";
const INVALID_DATE_RANGE_CODE_LIST = [
    CLIMATE_ACTION_INVALID_DATE_RANGE_CODE,
    PROJECT_INVALID_DATE_RANGE_CODE,
];
export function isInvalidDateRangeCode(code) {
    return code !== null && code !== undefined && INVALID_DATE_RANGE_CODE_LIST.includes(code);
}
